export default {
  name: 'ModalErrorComponent',
  props: ['name', 'show', 'close'],
};
